const selector = 'input.subscription-checkboxes[value="member"], input.subscription-checkboxes[value="normal"]';

function isVisible(input) {
  return input.offsetParent !== null;
}

function getScope(element) {
  return (
    element.closest('[id^="ProductInformation-"]') ||
    element.closest('featured-product-information') ||
    element.closest('.featured-product-section') ||
    element.closest('.shopify-section')
  );
}

function updateScope(scope, changedInput) {
  if (!scope) return;

  const disclaimers = scope.querySelectorAll('[data-membership-disclaimer-product]');
  disclaimers.forEach((disclaimer) => {
    const productId = disclaimer.dataset.membershipDisclaimerProduct;
    const inputs = [...scope.querySelectorAll(selector)].filter((input) => {
      return input.id.endsWith(`-${productId}`) && isVisible(input);
    });

    const selectedInput =
      changedInput && inputs.includes(changedInput)
        ? changedInput
        : inputs.find((input) => input.checked);

    disclaimer.hidden = selectedInput?.value !== 'member';
  });
}

function updateAll() {
  document.querySelectorAll('[data-membership-disclaimer-product]').forEach((disclaimer) => {
    updateScope(getScope(disclaimer));
  });
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches(selector)) return;
  updateScope(getScope(input), input);
});

// Labels and subscription widgets can change `checked` after their click handler
// runs without emitting another change event. Recheck on the next frame as well.
document.addEventListener('click', (event) => {
  const input = event.target.closest?.(selector);
  const labelInput = event.target.closest?.('.price-choice')?.querySelector(selector);
  const selectedInput = input || labelInput;
  if (!selectedInput) return;

  requestAnimationFrame(() => updateScope(getScope(selectedInput), selectedInput));
});

window.addEventListener('pageshow', updateAll);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateAll, { once: true });
} else {
  updateAll();
}

new MutationObserver(updateAll).observe(document.body, { childList: true, subtree: true });
